<template>
  <div class="app-container">
    <CrudTable entity="StandardUser" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: [
        { field: 'code', label: 'login.code' },
        'name',
        { field: 'roleNames', label: 'user.roles', filter: { type: 'none' }, sortable: false }
      ]
    };
  }
};
</script>

<style scoped></style>
